import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  Home, 
  Building2,
  ShoppingCart,
  ShoppingBag,
  RotateCcw,
  Users, 
  User,
  Package,
  Truck,
  FileText,
  Settings,
  LogOut,
  MapPin
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const navigation = [
  { name: 'Tableau de bord', href: '/dashboard', icon: Home },
  { name: 'Chantiers', href: '/chantiers', icon: Building2 },
  { name: 'Ventes', href: '/ventes', icon: ShoppingCart },
  { name: 'Achats', href: '/achats', icon: ShoppingBag, roles: ['admin', 'responsable_depot', 'responsable_bureau', 'responsable_equipe'] },
  { name: 'Retours chantier', href: '/retours', icon: RotateCcw, roles: ['admin', 'responsable_depot', 'responsable_bureau', 'responsable_equipe'] },
  { name: 'Produits', href: '/products', icon: Package },
  { name: 'Emplacements', href: '/products/locations', icon: MapPin, roles: ['admin', 'responsable_depot', 'responsable_bureau'] },
  { name: 'Fournisseurs', href: '/suppliers', icon: Truck, roles: ['admin', 'responsable_depot', 'responsable_bureau'] },
  { name: 'Magasins', href: '/magasins', icon: Package, roles: ['admin', 'responsable_depot', 'responsable_bureau'] },
  { name: 'Impressions', href: '/impressions', icon: FileText },
  { name: 'Import/Export', href: '/import-export', icon: FileText, roles: ['admin', 'responsable_bureau', 'responsable_depot'] },
  { name: 'Utilisateurs', href: '/users', icon: Users, roles: ['admin', 'responsable_bureau'] },
  { name: 'Historique', href: '/audit', icon: Settings, roles: ['admin'] },
];

function Sidebar() {
  const { user, logout, canAccess } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="flex flex-col h-full bg-white shadow-lg border-r border-gray-200">
      {/* Logo */}
      <div className="flex items-center h-20 px-4 bg-white border-b border-gray-200">
        <div className="flex items-center">
          <img 
            src="/logo Herminette (baseline).png" 
            alt="HERMINETTE" 
            className="w-auto filter drop-shadow-sm"
            style={{ height: '6rem' }}
          />
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-5 flex-1 px-2 space-y-1">
        {navigation.map((item) => {
          // Vérifier les permissions de rôle
          if (item.roles && !item.roles.includes(user?.role || '')) {
            return null;
          }

          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) => `
                group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors
                ${isActive 
                  ? 'bg-black text-white border-r-4 border-orange-400 shadow-lg' 
                  : 'text-gray-600 hover:bg-gray-100 hover:text-black'
                }
              `}
            >
              <item.icon className="mr-3 h-5 w-5" />
              {item.name}
            </NavLink>
          );
        })}
      </nav>

      {/* User info & Logout */}
      <div className="border-t border-gray-200 p-4 bg-gray-50">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="h-8 w-8 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full flex items-center justify-center shadow-lg">
              <User className="h-5 w-5 text-white" />
            </div>
          </div>
          <div className="ml-3 flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {user?.firstName} {user?.lastName}
            </p>
            <p className="text-xs text-gray-600 truncate capitalize">
              {user?.role?.replace('_', ' ')}
            </p>
          </div>
        </div>
        
        <div className="mt-3 space-y-1">
          <NavLink
            to="/profile"
            className="group flex items-center px-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-gray-100 hover:text-black transition-colors"
          >
            <Settings className="mr-3 h-4 w-4" />
            Profil
          </NavLink>
          
          <button
            onClick={handleLogout}
            className="w-full group flex items-center px-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-red-50 hover:text-red-600 transition-colors"
          >
            <LogOut className="mr-3 h-4 w-4" />
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;